export default function SectionHeading({
  eyebrow,
  title,
  lede,
}: {
  eyebrow: string;
  title: string;
  lede?: string;
}) {
  return (
    <div className="max-w-2xl">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-500">{eyebrow}</p>
      <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-50">
        {title}
      </h2>
      {lede ? <p className="mt-4 text-base text-ink-300 leading-relaxed">{lede}</p> : null}
    </div>
  );
}
